// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBZsYUysd48zNos0iLgzzdU9wBLLoytCN0",
    mapkey: 'AIzaSyBSRiezMIYW_YVkNcpotBXPfXTMMSbJYII',
    authDomain: "brr-smartfarm.firebaseapp.com",
    //databaseURL: "https://brd-farmluck-uat.firebaseio.com/",
    databaseURL: "https://brd-farmluck.firebaseio.com/",
    projectId: "brr-farmluck",
    storageBucket: "brr-farmluck.appspot.com",
    messagingSenderId: "377337176311",
    appId: "1:377337176311:web:12f9331898ef0b92f6b3f2",
    measurementId: "G-KT5XJF8TNH"
  },
  keycloak: {
    authority: 'https://sso-brd-gen3.appromo.info', // Keycloak server
    redirectUri: window.location.origin + '/#/Callback',
    //redirectUri: 'http://localhost:4200/#/Callback', // redirect
    postLogoutRedirectUri:  window.location.origin + '/#/Callback', // post logout url
    realm: 'brd-gen3',
    clientId: 'brd-gen3-app',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
